import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useCart } from "../../context/CartContext";

export default function EnquiryCartForm() {
  // TODO: Replace with your actual reCAPTCHA site key
  const RECAPTCHA_SITE_KEY = "6Lf3p0QrAAAAAHGcVJUBl0z999DFNxzUopth8mbS";

  const { cart } = useCart();

  // Form state
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    contact_person: "",
    country: "",
    address: "",
    message: ""
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaError, setCaptchaError] = useState("");

  // Cart summary string for Netlify Forms
  const cartSummaryString = cart
    .map(
      (item, idx) =>
        `${idx + 1}. ${item.name} (Code: ${item.sku}) - Qty: ${item.quantity}`
    )
    .join("\n");

  // Handle input changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setCaptchaError("");
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    if (!captchaValue) {
      e.preventDefault();
      setCaptchaError("Please complete the CAPTCHA to submit.");
      return;
    }

    // Detect if running locally (localhost or 127.0.0.1)
    const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    if (isLocalhost) {
      e.preventDefault();
      // Prepare form data for Netlify
      const formData = new FormData(e.target);
      try {
        await fetch('/', {
          method: 'POST',
          body: formData,
        });
        setSubmitted(true);
      } catch (error) {
        alert('Submission failed. Please try again.');
      }
    }
    // On Netlify, let default action proceed (redirect to /thank-you)
  };

  return submitted ? (
    <div className="p-8 bg-white rounded-xl shadow text-center">
      <h2 className="text-2xl font-bold mb-4">Thank you!</h2>
      <p>Your enquiry has been submitted successfully.</p>
    </div>
  ) : (
    <form
      action="https://formspree.io/f/mldbypwp"
      method="POST"
      className="w-full bg-white rounded-xl shadow p-4 sm:p-8 md:p-10"
      style={{
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)"
      }}
    >
      <input type="hidden" name="cart_summary" value={cartSummaryString} />
      <input type="hidden" name="_redirect" value="/thank-you" />

      <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 24 }}>
        Send Enquiry
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
  <input
    required
    name="name"
    placeholder="Name*"
    value={form.name}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
  <input
    required
    name="email"
    type="email"
    placeholder="Email*"
    value={form.email}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
  <input
    required
    name="phone"
    placeholder="Phone*"
    value={form.phone}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
  <input
    name="contact_person"
    placeholder="Contact Person"
    value={form.contact_person}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
  <input
    name="country"
    placeholder="Country"
    value={form.country}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
  <input
    name="address"
    placeholder="Address"
    value={form.address}
    onChange={handleChange}
    className="w-full p-3 rounded border border-gray-200"
  />
</div>
      <textarea
  name="message"
  placeholder="Message"
  value={form.message}
  onChange={handleChange}
  className="w-full min-h-[80px] mb-4 p-3 rounded border border-gray-200"
/>

      <button
        type="submit"
        disabled={cart.length === 0}
        className={`mt-3 inline-block w-full py-2 px-4 text-center rounded-md font-medium transition
          ${cart.length === 0 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-green-500 text-white hover:bg-green-600'}`}
      >
        {cart.length === 0 ? 'Cart is empty' : 'Send Enquiry'}
      </button>
      {/*
        To use reCAPTCHA, install the package:
        npm install react-google-recaptcha
        And replace RECAPTCHA_SITE_KEY with your own site key from Google reCAPTCHA admin.
      */}
    </form>
  );
}
